/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_VersionInputs */

const en_pc_online_cmp_version = /** @type {(inputs: Pc_Online_Cmp_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const zh_pc_online_cmp_version = /** @type {(inputs: Pc_Online_Cmp_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本`)
};

/**
* | output |
* | --- |
* | "Version" |
*
* @param {Pc_Online_Cmp_VersionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_version = /** @type {((inputs?: Pc_Online_Cmp_VersionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_VersionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_version(inputs)
	return zh_pc_online_cmp_version(inputs)
});
export { pc_online_cmp_version as "pc.online.cmp.version" }